
import { fuzzySearchPatient, showCreateForm } from './functions.js';

function do_fuzzy_patient_search() {
  clearTimeout(window.fuzzy_search);
  window.fuzzy_search = setTimeout(fuzzySearchPatient, 500);
}

function show_alert (message, message_type) {
  var toneClass = message_type === 'success' ? 'bg-green-50 border-green-200 text-green-800' : message_type === 'warning' ? 'bg-yellow-50 border-yellow-200 text-yellow-800' : message_type === 'info' ? 'bg-blue-50 border-blue-200 text-blue-800' : 'bg-red-50 border-red-200 text-red-800';
  var alert_el = "<div class='mb-4 flex items-start justify-between gap-3 rounded-md border p-4 " + toneClass + "' role='alert'>" +
    "<div class='text-sm font-medium'>" + message + "</div>" +
    "<button type='button' class='text-gray-400 hover:text-gray-600' aria-label='Close' onclick='this.parentElement.remove()'>&times;</button>" +
    "</div>";
  $("body").find(".js-alert-container").html(alert_el);
}

function reset_vitals_form(form) {
  if (!form || form.length === 0) return;
  form[0].reset();
}

function vitals_submit_form(e) {
  e.preventDefault();
  var form = $( e.target );
  if( form.length > 0 ) {
    $.ajax({
      type: "post",
      url: form.attr("action") + ".json",
      data: form.serialize(),
    })
    .done( function(data){
      if (data.success == true) {
        $(".js-vitals-panel").html(data.html);
        reset_vitals_form(form);
      }
      if (typeof ModalManager !== "undefined") {
        ModalManager.close("newVitalsModal");
      }
      show_alert(data.message, data.message_type);
    });
  }
}

function on_soap_hide(event) {
  var previous_trigger = event.detail && event.detail.previousTrigger;
  var previous_panel = event.detail && event.detail.previousTarget;
  if (!previous_trigger || !previous_panel) return;

  var previous_empty = $(".js-soap-input", previous_panel).val().length > 0;
  if(previous_empty) {
    $("i", previous_trigger).addClass("fa-check");
  } else {
    $("i", previous_trigger).removeClass("fa-check");
  }
}

var DOCTOR_DIAGNOSIS_SEARCH_DELAY = 300;

function current_diagnosis_id($dropdown) {
  var $field = $dropdown.closest(".js-diagnosis-field");
  var $hidden = $field.find("input[name$='[diagnosis_id]']").first();
  var diagnosis_id = $hidden.val() || $dropdown.data("diagnosis-id");

  return diagnosis_id ? String(diagnosis_id) : "";
}

function fetch_diagnoses(term, selected_id) {
  var params = {
    q: term || "",
    limit: 20
  };

  if (selected_id) {
    params.selected_id = selected_id;
  }

  return $.get("/diagnoses.json", params);
}

function request_diagnoses(term, selected_id, callback, error_callback) {
  return fetch_diagnoses(term, selected_id)
    .done(function(response) {
      if (callback) {
        callback(response || { results: [], more: false });
      }
    })
    .fail(function(xhr) {
      if (error_callback) {
        error_callback(xhr);
      }
    });
}

function diagnosis_query(options) {
  var term = options.term || "";
  var $dropdown = $(options.selectivity.el);
  var timer = $dropdown.data("diagnosis-query-timer");
  var delay = term.length > 0 ? DOCTOR_DIAGNOSIS_SEARCH_DELAY : 0;

  if (timer) {
    clearTimeout(timer);
  }

  timer = setTimeout(function() {
    request_diagnoses(
      term,
      current_diagnosis_id($dropdown),
      options.callback,
      options.error
    );
  }, delay);

  $dropdown.data("diagnosis-query-timer", timer);
}

function diagnosis_fields(index, target) {
  return $(
    `<div class="js-diagnosis-field w-[80%] flex flex-col gap-3 pt-6" data-index="${index}" data-target="${target}">
      <div class="flex items-start gap-3">
        <div class="min-w-0 flex-1">
          <div class="js-diagnosis-dropdown w-full" data-index="${index}" data-target="${target}"></div>
          <div class="js-diagnosis-hidden-container"></div>
        </div>
        <button type="button" class="js-remove-diagnosis inline-flex shrink-0 items-center justify-center rounded-md border border-transparent px-3 py-2 text-sm font-medium text-rose-600">
          Remove
        </button>
      </div>
      <textarea name="consult[soap][${target}][${index}][value]" rows='5' class='js-autosubmit js-soap-input m-0 block w-full rounded-md border-gray-300 shadow-sm focus:border-meclinic-teal focus:outline-none focus:ring-2 focus:ring-meclinic-teal sm:text-sm'></textarea>
    </div>`
  );
}

function on_selectivity_change(event) {
  var $dropdown = $(event.currentTarget || event.target);
  var index = $dropdown.data("index");
  var target = $dropdown.data("target");
  var diagnosis_id = event.value;
  var $field = $dropdown.closest(".js-diagnosis-field");

  var field_name = "consult[soap]["+ target +"]["+ index +"][diagnosis_id]";
  var $existing = $("input[name='"+field_name+"']", $field);

  if (diagnosis_id === null || diagnosis_id === undefined || diagnosis_id === "") {
    $existing.remove();
    return;
  }

  if($existing.length) {
    $existing.val(diagnosis_id);
  } else {
    $field.find(".js-diagnosis-hidden-container").append("<input type='hidden' value='"+ diagnosis_id +"' name='"+field_name+"'>");
  }
}

function remove_diagnosis_field(event) {
  event.preventDefault();
  $(event.currentTarget || event.target).closest(".js-diagnosis-field").remove();
}

function check_plan_action_input(element){
  var input_div = $(element).closest(".js-plan-action-with-value")
  var is_action_checked = $(input_div).find("input:checked").length > 0
  var action_value = $(input_div).find(".js-plan-action-value")
  var action_input = $(input_div).find(".js-plan-action-input")

  if (!is_action_checked) {
    action_value.val("");
    action_input.hide();
  } else {
    action_input.show();
  }
}

function setup_icd10_dropdown(context) {
  var selectivity_options = {
    allowClear: true,
    placeholder: "Select a diagnosis",
    query: diagnosis_query
  }
  var $dropdowns = context ? $(".js-diagnosis-dropdown", context) : $(".js-diagnosis-dropdown");

  $dropdowns.each(function() {
    var $dropdown = $(this);

    if (this.selectivity) {
      $dropdown.selectivity("destroy");
    }

    $dropdown.off("change", on_selectivity_change);
    $dropdown.selectivity(selectivity_options);
    $dropdown.on("change", on_selectivity_change);

    var diagnosis_id = $dropdown.data("diagnosis-id");
    if (typeof diagnosis_id !== "undefined" && diagnosis_id !== null && diagnosis_id !== "") {
      request_diagnoses("", diagnosis_id, function(response) {
        var results = response && response.results ? response.results : [];
        var selected_diagnosis = results.find(function(diagnosis) {
          return String(diagnosis.id) === String(diagnosis_id);
        });

        if (selected_diagnosis) {
          $dropdown.selectivity("data", selected_diagnosis);
        } else {
          $dropdown.selectivity("value", diagnosis_id);
        }
      });
    }
  });
}

var on_ready = function() {
  $("body").on( "submit", "#vitals_form", vitals_submit_form );

  $("#soap_submit").on("click", function(e){
    e.preventDefault;
    $("#soap_form").attr("action", $(e.target).data('form-path')).submit();
  });

  $("#end_consult").on("click", function(e){
    e.preventDefault;
    // console.log( $(e.target).data('form-path') );
    $("#soap_form").attr("action", $(e.target).data('form-path')).submit();
  });

  // $(".js-end-consultation").on("click", function(){
  //   submit_form(); // how is this working? :O
  // });

  $("#arriving_patient_form").on("keyup", do_fuzzy_patient_search)
  $(".showCreateForm").on("click", showCreateForm);
  document.addEventListener('tab:shown', on_soap_hide);

  if(typeof $("body").data('controller') != 'undefined' && ~ $("body").data('controller').indexOf('doctors')) { // only run when under doctors controllers
    setup_icd10_dropdown();

    $("body").off("click", ".js-remove-diagnosis", remove_diagnosis_field);
    $("body").on("click", ".js-remove-diagnosis", remove_diagnosis_field);

    $(".js-add-diagnosis").on("click", function(event) {
      event.preventDefault();
      var $target = $(event.currentTarget || event.target);
      var index   =+ $target.data("index");
      var target  = $target.data("target");
      var fields  = diagnosis_fields(index, target);

      setup_icd10_dropdown(fields);
      $(".js-"+target+"-diagnosis-fields").append(fields);
      $target.data("index", index + 1);

      if(typeof autosave === 'undefined'){
        var autosave = new AutoSaveSoap();
        autosave.on_ready();
      };

      return false;
    });

    $(".js-plan-action-with-value").each(function( index ) {
      check_plan_action_input(this);
      $( this ).on("change", function(e){
        check_plan_action_input ( $(e.target) );
      });
    });
  }
}

$(document).ready(on_ready);
$(document).on('page:load', on_ready);